import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { imgUrl } from "@/lib/api";
import { EASE } from "./Reveal";

const SPANS = [
  "lg:col-span-7 lg:row-span-2",
  "lg:col-span-5",
  "lg:col-span-5",
  "lg:col-span-4",
  "lg:col-span-4",
  "lg:col-span-4",
];

const Tile = ({ c, i }) => (
  <motion.div
    initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 1, ease: EASE, delay: (i % 3) * 0.08 }}
    className={`${SPANS[i] || "lg:col-span-4"} h-72 sm:h-80 lg:h-auto`}
  >
    <Link to={`/c/${c.slug}`} data-testid={`bento-cat-${c.slug}`}
      className="group relative block h-full overflow-hidden rounded-sm border border-[#D4AF37]/20 bg-[#13141C]">
      {c.cover_image && (
        <img src={imgUrl(c.cover_image)} alt={c.name} loading="lazy"
          className="absolute inset-0 w-full h-full object-cover opacity-70 scale-105 group-hover:scale-110 group-hover:opacity-90 transition-[transform,opacity] duration-[1400ms] ease-out" />
      )}
      <div className="absolute inset-0 bg-gradient-to-t from-[#0D0D11] via-[#0D0D11]/40 to-transparent" />
      <div className="absolute inset-0 p-6 sm:p-8 flex flex-col justify-between">
        <div className="flex justify-between font-mono-j text-[11px] uppercase tracking-[0.25em] text-[#E5C158]">
          <span>{String(i + 1).padStart(2, "0")}</span>
          <span data-testid={`bento-count-${c.slug}`}>{c.count ?? 0} items</span>
        </div>
        <div className="flex items-end justify-between gap-4">
          <div>
            <h3 className={`font-display text-[#F5F3EF] leading-none ${i === 0 ? "text-5xl sm:text-6xl" : "text-4xl"}`}>{c.name}</h3>
            {c.description && <p className="mt-3 max-w-sm text-sm text-[#A09E97]">{c.description}</p>}
          </div>
          <span className="shrink-0 w-12 h-12 rounded-full border border-[#D4AF37]/40 grid place-items-center text-[#E5C158] group-hover:bg-[#D4AF37] group-hover:text-[#0D0D11] transition-colors duration-500">
            <ArrowUpRight className="w-5 h-5 group-hover:rotate-45 transition-transform duration-500" />
          </span>
        </div>
      </div>
    </Link>
  </motion.div>
);

export const CategoryBento = ({ cats }) => (
  <div className="grid grid-cols-1 lg:grid-cols-12 lg:auto-rows-[300px] gap-4" data-testid="category-bento">
    {cats.map((c, i) => <Tile key={c.id} c={c} i={i} />)}
  </div>
);
